import React from 'react';
import { Link } from 'react-router-dom';
import PageLayout from './PageLayout';
import './Dashboard.css';

const Dashboard: React.FC = () => {
  return (
    <PageLayout title="Dashboard">
      <div className="dashboard-welcome">
        <p>Manage venues, events, artists, and monitor system status.</p>
        <div className="dashboard-cards">
          <Link to="/venues" className="dashboard-card">
            <h3>Venues</h3>
            <p>Manage venue information</p>
          </Link>
          <Link to="/venues/allowlist" className="dashboard-card">
            <h3>Venue Allowlist</h3>
            <p>Manage venue allowlist entries</p>
          </Link>
          <Link to="/venues/groups" className="dashboard-card">
            <h3>Venue Grouping</h3>
            <p>Manage venue groups and consolidate duplicate venues</p>
          </Link>
          <Link to="/events" className="dashboard-card">
            <h3>Events</h3>
            <p>Manage events and shows</p>
          </Link>
          <Link to="/artists" className="dashboard-card">
            <h3>Artists</h3>
            <p>Manage artist information</p>
          </Link>
          <Link to="/ingestion" className="dashboard-card">
            <h3>Ingestion</h3>
            <p>Trigger Ticketmaster, Etix, EventIM, and scraper ingestion</p>
          </Link>
          <Link to="/regions" className="dashboard-card">
            <h3>Regions</h3>
            <p>Manage geographic regions for ingestion</p>
          </Link>
          <Link to="/usage" className="dashboard-card">
            <h3>API Usage</h3>
            <p>View API usage statistics</p>
          </Link>
          <Link to="/subscriptions" className="dashboard-card">
            <h3>Email Subscriptions</h3>
            <p>Manage email subscriptions</p>
          </Link>
          <Link to="/cdn" className="dashboard-card">
            <h3>CDN Management</h3>
            <p>Manage CDN assets and files</p>
          </Link>
          <Link to="/share-activity" className="dashboard-card">
            <h3>Share Activity</h3>
            <p>View share shortener activity and trends</p>
          </Link>
          <Link to="/admin/venue-views" className="dashboard-card">
            <h3>Venue Views</h3>
            <p>Most popular venues from view events</p>
          </Link>
          <Link to="/admin/calendar-views" className="dashboard-card">
            <h3>Calendar Views</h3>
            <p>GET /calendar traffic by region (stagespotter-calendar-views)</p>
          </Link>
          <Link to="/admin/ticket-clicks" className="dashboard-card">
            <h3>Ticket Clicks</h3>
            <p>Most popular events and artists from ticket clicks</p>
          </Link>
          <Link to="/api-explorer" className="dashboard-card">
            <h3>API Explorer</h3>
            <p>Browse Ticketmaster, Etix, EventIM and Spotify data and make live calls</p>
          </Link>
        </div>
      </div>
    </PageLayout>
  );
};

export default Dashboard;

